import React from 'react';
import { Link } from 'react-router-dom';

const ProjectPropOne = ({ portfolio }) => {

  return (
    <>
      <div className={`project-grid`}>
        <div className="thumbnail">
          <Link to={portfolio.link}>
            <img src={process.env.PUBLIC_URL + portfolio.image} alt="icon" width="1260" height="542"/>
          </Link>
        </div>
        <div className="content">
          <p className="title h4">
            <Link to={portfolio.link}>{portfolio.title}</Link>
          </p>
          <span className="subtitle">
            {portfolio.category && portfolio.category.map((cat, i) => (
              <span key={i}>{cat}</span>
            ))}
          </span>
        </div>
      </div>
    </>
  );
}

export default ProjectPropOne;
